import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IMaritalStatusState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IMaritalStatusState = {
  list: [],
  isLoading: false,
};